(function () {
  if (window.__weavaCartDeferredLoader) return;
  window.__weavaCartDeferredLoader = true;

  const assets = window.__weavaDeferredCartAssets || {};
  let loading;

  function loadStyle(href) {
    if (!href || document.querySelector('link[href="' + href + '"]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadScript(src) {
    if (!src || document.querySelector('script[src="' + src + '"]')) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadCartAssets() {
    if (loading) return loading;
    loadStyle(assets.shippingProtectionCss);
    loadStyle(assets.bundleGiftCss);
    loading = Promise.all([
      loadScript(assets.shippingProtectionJs),
      loadScript(assets.bundleGiftJs),
    ]).catch((error) => {
      console.warn('[cart-deferred-loader] failed to load cart assets', error);
    });
    return loading;
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-drawer-toggle], a[href="/cart"], a[href*="/cart"]')) {
      loadCartAssets();
    }
  }, { capture: true });

  document.addEventListener('theme:cart:add', loadCartAssets, { once: true });
  document.addEventListener('theme:cart:added', loadCartAssets, { once: true });
  document.addEventListener('theme:cart:loaded', loadCartAssets, { once: true });
  document.addEventListener('theme:cart:refresh', loadCartAssets, { once: true });

})();
